import { Link } from "react-router-dom";

export default function PageHeader({
    overline,
    title,
    subtitle,
    image,
    breadcrumb = [],
    testId = "page-header",
}) {
    return (
        <section
            data-testid={testId}
            className="relative bg-[#101A2C] text-white overflow-hidden grain-overlay"
        >
            {image && (
                <>
                    <img
                        src={image}
                        alt=""
                        className="absolute inset-0 w-full h-full object-cover opacity-30"
                        loading="eager"
                    />
                    <div className="absolute inset-0 bg-gradient-to-r from-[#101A2C] via-[#101A2C]/85 to-[#101A2C]/40" />
                </>
            )}
            <div className="relative container-vl pt-20 pb-16 md:pt-28 md:pb-20">
                {breadcrumb.length > 0 && (
                    <nav
                        className="flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-[#CBD5E1] mb-6"
                        data-testid="page-breadcrumb"
                    >
                        <Link to="/" className="hover:text-[#F4A000]">Home</Link>
                        {breadcrumb.map((b, i) => (
                            <span key={i} className="flex items-center gap-2">
                                <span>/</span>
                                {b.href ? (
                                    <Link to={b.href} className="hover:text-[#F4A000]">{b.label}</Link>
                                ) : (
                                    <span className="text-[#F4A000]">{b.label}</span>
                                )}
                            </span>
                        ))}
                    </nav>
                )}
                {overline && <p className="overline mb-4">{overline}</p>}
                <h1 className="heading-h1 max-w-4xl text-white text-balance">{title}</h1>
                {subtitle && (
                    <p className="mt-6 text-base md:text-lg text-[#CBD5E1] max-w-2xl leading-relaxed">
                        {subtitle}
                    </p>
                )}
            </div>
            {/* Bottom orange industrial accent strip */}
            <div className="relative h-2 bg-[#F4A000]" />
        </section>
    );
}
